<template>
  <div class="about-container">
    <img class="title"
         src="../assets/about-us-title.svg" />
    <nav>
      <router-link to="/about/us/founding-story">創辦故事</router-link>
      <router-link to="/about/us/educational-concept">教育理念</router-link>
    </nav>
    <Divider class="divider" />
    <router-view />
  </div>
</template>

<script>
import Divider from "@/components/Divider.vue";

export default {
  components: {
    Divider
  }
};
</script>

<style lang="scss" scoped>
.about-container {
  .title {
    display: block;
    margin: 80px auto;
    width: 135px;
  }

  nav {
    display: grid;
    grid-template-areas: ". .";
    grid-gap: 120px;
    justify-content: center;

    a {
      background-color: #f3f3f4;
      border-radius: 14px;
      text-decoration: none;
      color: #6b6b6b;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 25px;

      &.router-link-active,
      &:hover {
        background-color: #c4cb7a;
        color: white;
      }
    }
  }

  .divider {
    max-width: 848px;
    margin: 30px auto;
  }
}

@media (max-width: 1023px) {
  .title {
    margin: 20px auto !important;
  }

  nav {
    grid-gap: 25px !important;

    a {
      font-size: 12px !important;
      padding: 9px 15px !important;
    }
  }

  .divider {
    margin: 12px 5px !important;
  }
}
</style>
